module.exports = require("@vscode/base-node/vs/base/node/config");